import { helpers } from 'vuelidate/lib/validators'
import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  });

export default ssn =>
  helpers.withParams(
    { type: 'ssn', ssn: ssn },
    function(value, parentVm) {
        if (!value || (value && value.trim().length === 0) || (value && value.trim().length < 9) ) {
            return true
        } else {
            const payload = {
                ssn: value,
                isGuest: ssn.guest === 'GUEST',
                isInternational: ssn.international
            }
            return new Promise(async function (resolve) {
                await axios.post(`${process.env.VUE_APP_API_BASE_URL}/license/ssn`, payload)
                    .then((response) => resolve(response.data));
            })
        }
    }
  )